const images = {
  logo: require('./logo_fife.png'),
  logoMini: require('./logo-mini.png'),
};

export default images;
